window.valid_postcode = function valid_postcode(postcode) {
    'use strict';

    postcode = postcode.replace(/\s/g, '');
    var regex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
    return regex.test(postcode);

}

/*
 * Change Address Function
 */

window.change_address = function change_address(index_value) {
    'use strict';

    var selected,
        address1,
        address2,
        city,
        seltext,
        addressLines,
        secondline,
        sizeof;


    selected = $('#address_list_'+  index_value  +' option:selected');
    address1 = $('input[data-type="address_line_1_' + index_value + '"]');
    address2 = $('input[data-type="address_line_2_' + index_value + '"]');
    city = $('input[data-type="city_' + index_value + '"]');


    // get selected values inner text
    seltext = selected.val();
    // split the selected text into an array of parts we can use
    addressLines = seltext.split(', ');
    sizeof = addressLines.length;
    secondline = '';


    if (sizeof === 4) {
        secondline = addressLines[1] + ', ' + addressLines[2];
    } else if (sizeof === 3) {
        secondline = addressLines[1];
    }

    addressLines[0] = addressLines[0].replace('|', ',');
    secondline = secondline.replace('|', ',');


    // set input boxes values to the values of the array
    address1.val(addressLines[0]).trigger('change');
    address2.val(secondline).trigger('change');
    city.val(addressLines[sizeof - 1]).trigger('change');
}

/*
 * Postcode Lookup
 */

window.postcode_lookup = function postcode_lookup(index_value) {
    'use strict';

    // set variables depending on if its billing/shipping.
    var postcodeSearchInput,
        postcodeSearchOutput,
        postcodeCurrentlySelected,
        unhide,
        postcode;


        postcodeSearchInput = $('input[data-type="postcode_' + index_value + '"]');
        postcodeSearchOutput = $('#address_list_' +  index_value);
        postcodeCurrentlySelected = $('#address_list_' +  index_value + ' option:selected');
        unhide = $('#pafListing' +  index_value);


    // get postcode value from input & strip spaces
    postcode = postcodeSearchInput.val().replace(' ', '');

    $.ajax({
        type: 'post',
        url: '/plugins/PAFLookup/ajax/ajax_postcode.php',
        data : 'postcode=' + postcode,
        dataType : 'html',
        success: function (html) {
            postcodeSearchOutput.html(html);
            unhide.show();
            $('select').trigger('chosen:updated');
            $('select').each(function () {
                $(this).parent().find('span').text($('option:selected', $(this)).text());
            });
        }
    });

}


$( document ).ready(function() {
/*
 * Postcode Lookup
 */

    $('#pafListing1, #pafListing2, #pafListing3').hide();


    $('body').on('click', 'button[id^="postCodeSearchSubmit"]', function (e) {

        e.preventDefault();
        var the_index = $(this).data('index');

        var clearPafFields = $('input[data-type="address_line_1_' + the_index + '"], input[data-type="address_line_2_' + the_index + '"], input[data-type="city_' + the_index + '"]');

        if ($('input[data-type="postcode_' + the_index + '"]').val() === '') {
            $('input[data-type="postcode_' + the_index + '"]').addClass('inputError');
        } else {

            clearPafFields.map(function() {
                $(this).val('');
            });

            postcode_lookup(the_index);
        }
    });


    $('body').on('change', '.pafAddressList', function (e) {
        var index_value = $(this).data('index');
        change_address(index_value);
    });
});
